import React, { useContext, useMemo, useState } from "react";
import { PropTypes } from "prop-types";

const MediaPipelinesContext = React.createContext(null);

export const useMediaPipelines = () => useContext(MediaPipelinesContext);

const propTypes = {
    children: PropTypes.node.isRequired,
    mediaPipelines: PropTypes.array
};

const defaultProps = {
    mediaPipelines: null
};

export const MediaPipelinesProvider = ({ mediaPipelines: initialData, children }) => {
    const [data] = useState(initialData);

    const value = {
        mediaPipelines: data
    }
    return <MediaPipelinesContext.Provider value={value}>{children}</MediaPipelinesContext.Provider>
};

MediaPipelinesContext.propTypes = propTypes;
MediaPipelinesContext.defaultProps = defaultProps;

export default MediaPipelinesContext;
